import '../../config-provider/index.js';
import { defaultPrefixCls } from '../../config-provider/context.js';
const TARGET_CLS = `${defaultPrefixCls}-wave-target`;
export { TARGET_CLS };
//# sourceMappingURL=interface.js.map
